import React from 'react';

import { FlexRow } from 'ui-components/components/flex';

import AmountSummary from './amount-summary';
import Dates from './dates';
import InformationBanner from './information-banner';
import messages from './messages';
import style from './order-details-section.module.less';
import { OrderNumber } from './order-number';
import ShipToAddress from './ship-to-address';
import SoldTo from './sold-to';
import { OrderDetailsSectionId } from '../../fulfillment-plan/order-details-expanded-section-provider';
import ExpanderSection from '../../tab-section/expander-section/expander-section';
import SectionTitle from '../../tab-section/title';

export const OrderDetailsSection = () => {
  return (
    <ExpanderSection
      ariaLabelMessageDescriptor={messages.orderDetailsSectionLabel}
      className={style['expander-section']}
      contentClassName={style['expander-content-order-details']}
      headerContent={<SectionTitle messageDescriptor={messages.orderDetails} />}
      sectionContent={
        <>
          <InformationBanner />
          <OrderNumber />
          <SoldTo />
          <ShipToAddress />
          <FlexRow>
            <AmountSummary />
            <Dates />
          </FlexRow>
        </>
      }
      sectionId={OrderDetailsSectionId.OrderDetails}
    />
  );
};
